import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TemplateEditorComponent } from '../../components/templates/template-editor.component';
import { TemplatesListComponent } from '../../components/templates/templates-list.component';

const routes: Routes = [
  {
    path: '',
    component: TemplatesListComponent,
  },
  {
    path: 'new',
    component: TemplateEditorComponent,
  },
  {
    path: 'edit/:id',
    component: TemplateEditorComponent,
  },
  {
    path: 'sample/:sampleId',
    component: TemplateEditorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminTemplatesRoutingModule {}
